import { wsBridge, wsStore, wsUserId } from "@/shared/api/websocket"
import { isActiveBoardUser } from "@/shared/lib/active-board"
import { updateFriendInCache } from "../lib/update-friend-cache"
import { friendKeys } from "../model/keys"

export function registerFriendSync(): void {
	// Invalidate on EVERY connect, the first one included, with no threshold on
	// how long the socket was down: the list lives with staleTime Infinity and is
	// patched only by pushes, so any window without a socket can cost a missed
	// event, and GET /friends is the only authoritative snapshot.
	wsStore.on("state", ({ isConnected }) => {
		if (!isConnected) return
		const { queryClient } = wsBridge.getContext()
		const userId = wsUserId()
		if (!queryClient || !userId) return

		const queryKey = friendKeys.list(userId)
		const state = queryClient.getQueryState(queryKey)
		if (state?.status === "error" && state.data === undefined) return
		queryClient.invalidateQueries({ queryKey })
	})

	wsBridge.subscribe("presence.update", (payload, queryClient) => {
		const userId = wsUserId()
		if (!userId) return
		const { user_id: friendId, is_online, last_seen_at, board } = payload

		const shouldUpdateUnread = board !== null && !isActiveBoardUser(friendId)

		updateFriendInCache(queryClient, userId, friendId, (friend) => ({
			...friend,
			is_online,
			last_seen_at,
			...(shouldUpdateUnread && { unread_board: !board.incoming.read }),
		}))
	})

	wsBridge.subscribe("board.update", (payload, queryClient) => {
		const userId = wsUserId()
		if (!userId) return
		if (payload.kind !== "content" || isActiveBoardUser(payload.from_user_id))
			return
		updateFriendInCache(
			queryClient,
			userId,
			payload.from_user_id,
			(friend) => ({
				...friend,
				unread_board: true,
			}),
		)
	})
}
